// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"d3df15d3","453":"abbee096"}[chunkId] + ".chunk.js";
};